import { render, staticRenderFns } from "./LtkPostCaption.vue?vue&type=template&id=23323838&scoped=true"
import script from "./LtkPostCaption.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkPostCaption.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkPostCaption.vue?vue&type=style&index=0&id=23323838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23323838",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,CBottomSheet: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBottomSheet/CBottomSheet.vue').default})
